// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/AddAction/AddDialog/Content/OrganizationChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Leads_AddAction_AddDialog_Content_OrganizationChooser($id: uuid) {
  location_division: vaxiom_sys_organizations(where: { _id: { _eq: $id } }) {
    _id
    name
    level
    parent {
      _id
      name
      level
    }
  }
  locations: vaxiom_sys_organizations(where: { level: { _eq: "location" } }) {
    _id
    name
    level
    parent {
      _id
      name
      level
    }
  }
}

`